import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from "@material-ui/core/CircularProgress";
import TableContainer from "@material-ui/core/TableContainer";
import moment from "moment";
import axiosInstance from "../../config/AxiosConfig";
import Tooltip from "@material-ui/core/Tooltip";
import { getToken } from './../../config/storageData';

const useStyles = makeStyles({
    root: {
        cursor: 'pointer',
    },
    rent: {
        backgroundColor: 'rgba(225, 190, 231, 0.7)',
    },
    pool: {
        backgroundColor: 'rgba(187, 222, 251, 0.7)',
    },
    progress: {
        flex: 1,
        height: '72px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    table: {
        maxHeight: "55vh"
    }
});

const checkEndDate = date => {
    console.log('date :>> ', date);
    if(date == 0)
        return "Brak daty zakończenia";
    return moment.unix(date).format('YYYY-MM-DD hh:mm:ss');
}

const CarRentalListDialog = (
    {
        isCarRentalListDialogOpen,
        onCloseCarRentalListDialog,
        editRentHandler,
        car,
    }
) => {
    const classes = useStyles();
    const [token] = useState(getToken());
    const [rentList, setRentList] = useState(null);

    useEffect(() => {
        if(isCarRentalListDialogOpen)
            getCarRentalList(token, car.id);
    }, [isCarRentalListDialogOpen]);

    const getCarRentalList = (token, carId) => {
        axiosInstance
            .post("kalendarz/lista_wynajmow.php",
                {
                    token,
                    id_samochod: carId,
                })
            .then(response => {
                let newData = response.data.data.map(data => {
                    if (!data.dystans_przed || data.dystans_przed === -1)
                        data.dystans_przed = "b.d.";
                    if (!data.dystans_po || data.dystans_po === -1)
                        data.dystans_po = "b.d.";
                    if (!data.dystans_pokonany || data.dystans_pokonany === -1)
                        data.dystans_pokonany = "b.d.";
                    return data;
                });
                setRentList(newData);
            });
    };

    const onRentSelection = (rent) => {
        console.log(rent);
        editRentHandler(rent.id_wynajem)
    };

    const printList = data => {
        if(!Array.isArray(data) || data.length === 0)
            return <TableCell colSpan={8}>Brak danych</TableCell>
        return (
            data.map(row => (
                <Tooltip key={row.id_wynajem}
                    title={`Edycja ${row.typ}`} placement="bottom">
                    <TableRow
                        style={{ cursor: "pointer" }}
                        className={[classes.root, row.typ === 'Pool' ? classes.pool : classes.rent]}
                        hover={true}
                        onClick={() => {
                            onRentSelection(row)
                        }}>
                        <TableCell
                            align="left">
                            {moment.unix(row.data_od).format('YYYY-MM-DD hh:mm:ss')}
                        </TableCell>

                        <TableCell
                            align="left">
                            {checkEndDate(row.data_do)}
                        </TableCell>
                        <TableCell align="left">{row.kierowca}</TableCell>
                        <TableCell align="left">{row.operator}</TableCell>
                        <TableCell align="left">{row.dystans_przed}</TableCell>
                        <TableCell align="left">{row.dystans_po}</TableCell>
                        <TableCell align="left">{row.dystans_pokonany}</TableCell>
                        <TableCell align="left">{row.opis}</TableCell>
                    </TableRow>
                </Tooltip>
            ))
        )
    }

    return (
        <Dialog
            onClose={onCloseCarRentalListDialog}
            fullWidth={true}
            maxWidth="xl"
            aria-labelledby="customized-dialog-title"
            open={isCarRentalListDialogOpen}
        >
            <DialogTitle id="customized-dialog-title">
                Lista najmów samochodu: {car.rejestracja} - {car.marka} {car.model}
            </DialogTitle>
            <DialogContent>
                <p>
                    <span style={{ marginRight: "8px" }}>Typ: <b>{car.typ_auta}</b></span>
                    <span style={{ marginRight: "8px" }}>Opis: <b>{car.opis}</b></span>
                </p>

                {rentList ?
                <TableContainer
                className={classes.table}>
                    <Table
                        aria-label="Cars Rental Table"
                        size="small"
                        stickyHeader
                    >
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">Od</TableCell>
                                <TableCell align="left">Do</TableCell>
                                <TableCell align="left">Kierowca</TableCell>
                                <TableCell align="left">Operator</TableCell>
                                <TableCell align="left">Stan licznika przed</TableCell>
                                <TableCell align="left">Stan licznika po</TableCell>
                                <TableCell align="left">Dystans pokonany</TableCell>
                                <TableCell align="left">Opis</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {printList(rentList)}
                        </TableBody>
                    </Table>
                    </TableContainer>
                    :
                    <div className={classes.progress}>
                        <CircularProgress />
                    </div>
                }
            </DialogContent>
            <DialogActions>
                <Button autoFocus onClick={onCloseCarRentalListDialog} color="primary">
                    OK
                </Button>
            </DialogActions>
        </Dialog>

    );
};

export default CarRentalListDialog;